import { Typography } from '@mui/material';
import React from 'react';
import { colors } from '../../Themes/colors';
var TextBottomLine = function (_a) {
    var headingTitle = _a.headingTitle, pb = _a.pb;
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography, { variant: "body1", pb: pb, borderBottom: "1px solid ".concat(colors.greyShades[12]), fontWeight: 600, color: colors.blueShades[10] }, headingTitle)));
};
export default TextBottomLine;
